<template>
  <!-- 悬浮 -->
   <div class="christmas-float"  @click="jump">
     <img src="https://act.mcake.com/fangli/2019/new-PC/new/images/icon-ybj.png" alt="">
   </div>
</template>
<script>
  export default {
    name: 'home-float',
    data () {
      return {
        cityId: window.store.get('city_id'),
        notice: ''
      }
    },
    mounted () {
      //this.load()
    },
    methods: {
     jump () {
         window.location.href = '/#/promotion?id=2249&type=2'
      }
    }
  }
</script>
<style scoped>
  .christmas-float{ width: 2rem; position: fixed; bottom: 5.5rem; right: 0; z-index: 100;}
</style>



// WEBPACK FOOTER //
// src/components/home/home-float.vue